
let React =              require("react");
const {  Link  } = require('react-router-dom');

let Utility =            require("../util/Utilities.js");
 
let LoadingCard =        require("./cards/LoadingPlaceholder.jsx");
let CircuitsUtil = require("../util/CircuitsUtil.js");
let RestoreButton = require("./buttons/infoPageButtons/RestoreInfoButton.jsx");

class AssetInfo extends React.Component {

    constructor(){
        super(); 
    }

    formatName(name){
        return name.replace(/ /g,"-");
    }

    renderVersion(newVersion, version){
        if(version == -1)
            return "";
        else
            return (<span className={newVersion ? "version new": "version"}>V{version}</span>)
    }

    renderMetaData(MetaData, properties) {
        return (
            <div className="infoLibrary__info__metadata">
                <MetaData
                    data = {properties}
                />
            </div>
        );
    }

    render() {
        if(!this.props.resource){ return <LoadingCard/> }

        
        const { name, user_name, description, updated_at, deleted, properties, user_id } = this.props.resource;
        const { displayName, premiumButtons, buttons, hub, location: {state: {newVersion} = {newVersion: false}}, MetaData, current_user_id } = this.props;

        let version = CircuitsUtil.getMostRecentVersion(this.props.resource);
        let isPrivate = this.props.resource.private;

        let hubAlive = (hub && !hub.deleted) || current_user_id != user_id;
        
        let isPremiumAccount = (/(premium|education)/gi.test(this.props.typeUser));

        let stylePrivate = isPrivate ? "": "public";

        return  <div className="infoLibrary">
                    <div className="infoLibrary__info">
                        <div className="infoLibrary__info__title">
                            {name} <span>| {displayName}</span> {this.renderVersion(newVersion, version)}
                        </div>
                        <div className="infoLibrary__info__owner">by {user_name}</div>
                        <div className="infoLibrary__info__description" dangerouslySetInnerHTML={{
                            __html: Utility.formatDescription(description)}}>
                        </div>
                        {MetaData && this.renderMetaData(MetaData, properties)}
                        <div className="infoLibrary__info__date">Last Updated {Utility.formatDateString(updated_at)}</div>
                        <div className="infoLibrary__info__isprivate">
                            <div className={`icon ${stylePrivate}`}></div>
                            <div>{isPrivate ? "Private": "Public"}</div>
                        </div>
                        <div className="infoLibrary__info__permaLink">
                            <div className="infoLibrary__info__permaLink__title">Permalink</div>
                            <div className="infoLibrary__info__permaLink__link">{window.location.href}</div>
                        </div>
                    </div>
                    <div className="infoLibrary__options">
                    
                    { !deleted && hubAlive && isPremiumAccount && premiumButtons && premiumButtons.map((Button, ind) => <Button key={ind} version={version} {...this.props} />)}

                    { !deleted && hubAlive && buttons.map((Button, ind) => <Button key={ind} version={version} {...this.props} />)}

                    { deleted && hubAlive && <RestoreButton {...this.props} />}

                    </div>
                </div>
    }
}

module.exports = AssetInfo;
